import { Platform } from 'helpers/platform';
import get from 'lodash/get';
import { addNotificationHandler } from 'store/middleware/displayNotification';
import { NOTIFICATIONS_SPRINT_RULES } from '@lingoda/notifications';
import { currentRoutePathSelector } from '@lingoda/router';
import { studentSelector } from '@lingoda/students';

void addNotificationHandler({
    check: (state) => {
        const student = studentSelector(state);

        if (!student) {
            return;
        }

        const currentRoutePath = currentRoutePathSelector(state);
        const route = currentRoutePath && currentRoutePath.route;
        const sprintNotifications = get(
            student,
            'preferences.notifications.' + NOTIFICATIONS_SPRINT_RULES,
        );

        if (
            sprintNotifications &&
            sprintNotifications !== '0' &&
            route !== 'paymentFailedPath' &&
            route !== 'paymentPendingPath'
        ) {
            return { type: 'sprintRules' };
        }
    },
    once: true,
    platforms: [Platform.SBE],
});
